import {Action} from '@ngrx/store';
import * as _ from 'lodash';
import {billingProductsActionTypes, LoadBillingProductsSuccessAction} from '../actions/billing-product';
import {BillingProduct} from '../models/product';

export interface BillingProductsState {
  array: BillingProduct[];
}

const initialState: BillingProductsState = {
  array: []
};

export function billingProductsReducer(state: BillingProductsState = initialState, action: Action): BillingProductsState {
  switch (action.type) {
    case billingProductsActionTypes.LOAD_SUCCESS:
      return handleLoadSuccessAction(state, action);
    case billingProductsActionTypes.LOAD_FAIL:
      return handleLoadFailAction(state);
    default:
      return state;
  }
}

function handleLoadSuccessAction(state: BillingProductsState, action: LoadBillingProductsSuccessAction): BillingProductsState {
  const newState = _.clone(state);
  newState.array = action.payload;
  return newState;
}



function handleLoadFailAction(state: BillingProductsState): BillingProductsState {
  const newState = _.clone(state);
  newState.array = [];
  return newState;
}
function handleLoadClearAction(state: BillingProductsState): BillingProductsState {
  return initialState;
}

export const billingProductsSelectors = {
  array: (state: BillingProductsState) => _.get(state, 'array', [])
};
